import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { ConfigProvider, Col, Row, AutoComplete, Tooltip, List } from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  setTextSearch,
  setSearchBarPosition,
} from "../../../redux/features/main/searchSlice";
import { setLocalStorage, getLocalStorage } from "../../../utils";
import { useTranslation } from "react-i18next";
import { colorTextTitle } from "../../../config/constant/color/index";
import { use } from "react";

const SearchMobileVersion = ({ isContentLibraryPage = false, mainState }) => {
  const isCollectionCL = useSelector((state) => state.search.isCollectionCL);
  const dispatch = useDispatch();
  const historySearch = getLocalStorage("search_cl");
  const { t, i18n } = useTranslation();
  const { Option } = AutoComplete;

  const [itemsSearchBar, setItemsSearchBar] = useState([]);
  const [searchBarPage, setSearchBarPage] = useState("");
  const [isOpenTooltipToolbar, setIsOpenTooltipToolbar] = useState(false);
  const [tooltipMessage, setTooltipMessage] = useState("");
  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const [valueSearch, setValueSearch] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const [isShowRecentSearch, setIsShowRecentSearch] = useState(false);

  const location = useLocation();
  const locPathname = location.pathname;

  const handleSelectSearchBar = (value) => {
    setIsOpenSelect(false);
    dispatch(setTextSearch(value));
    setSearchParams({ search: value });
    dispatch(setSearchBarPosition(searchBarPage));

    // local Storage things to save, read, and set
    const historyValue =
      Array.isArray(getLocalStorage(searchBarPage)) === true
        ? getLocalStorage(searchBarPage)
        : JSON.parse(getLocalStorage(searchBarPage));

    const arrayHistory = historyValue,
      index = arrayHistory.findIndex((v) => v === value);

    if (index !== -1) arrayHistory.unshift(...arrayHistory.splice(index, 1));

    // trim array to only 5 history
    const trimArr =
      arrayHistory.length > 5 ? arrayHistory.slice(0, 5) : arrayHistory;

    setLocalStorage(searchBarPage, JSON.stringify(trimArr));

    setValueSearch(value);
  };

  // const handleSelectSearch = (value) => {
  //   dispatch(setTextSearch(value));
  //   setSearchParams({ search: value });
  //   // local Storage things to save, read, and set
  //   const historyValue =
  //     Array.isArray(getLocalStorage("search_cl")) === true
  //       ? getLocalStorage("search_cl")
  //       : JSON.parse(getLocalStorage("search_cl"));

  //   const arrayHistory = historyValue,
  //     index = arrayHistory.findIndex((v) => v === value);

  //   if (index !== -1) arrayHistory.unshift(...arrayHistory.splice(index, 1));

  //   // trim array to only 5 history
  //   const trimArr =
  //     arrayHistory.length > 5 ? arrayHistory.slice(0, 5) : arrayHistory;

  //   setLocalStorage("search_cl", JSON.stringify(trimArr));
  // };

  const deleteOption = (value) => {
    setItemsSearchBar(
      itemsSearchBar.filter((item) => {
        return item.value !== value;
      }),
    );
    let historySearchToDelete =
      Array.isArray(getLocalStorage(searchBarPage)) === true
        ? getLocalStorage(searchBarPage)
        : JSON.parse(getLocalStorage(searchBarPage));

    historySearchToDelete = historySearchToDelete.filter((e) => e !== value);

    setLocalStorage(searchBarPage, JSON.stringify(historySearchToDelete));
  };

  const handleOnSearch = (value) => {
    if ((value.length < 3 && value.length !== 0) || value.length >= 50) {
      setIsOpenTooltipToolbar(true);
      if (value.length < 3 && value.length !== 0) {
        setTooltipMessage(t("feature.feature_search.please_enter"));
      } else {
        setTooltipMessage(t("feature.feature_search.limit_char_reach"));
      }
    } else {
      setIsOpenTooltipToolbar(false);
    }
    // if (value) {
    //   if (itemsSearchBar.length > 0) {
    //     if (isContentLibraryPage) {
    //       setIsShowRecentSearch(true);
    //     }
    //   }
    // }
    setValueSearch(value);
  };

  const handleEnter = (value) => {
    // keyCode for button Enter
    if (value.keyCode === 13) {
      if (valueSearch.length >= 3) {
        // console.log("Enter !!");

        setIsOpenSelect(false);

        dispatch(setTextSearch(valueSearch));
        setSearchParams({ search: valueSearch });
        dispatch(setSearchBarPosition(searchBarPage));

        // local Storage things to save, read, and set
        const historySearchMylj =
          Array.isArray(getLocalStorage(searchBarPage)) === true
            ? getLocalStorage(searchBarPage)
            : JSON.parse(getLocalStorage(searchBarPage));

        if (historySearchMylj.indexOf(valueSearch) === -1) {
          historySearchMylj.unshift(valueSearch);
        }

        // trim array to only 5 history
        const trimArr =
          historySearchMylj.length > 5
            ? historySearchMylj.slice(0, 5)
            : historySearchMylj;

        setLocalStorage(searchBarPage, JSON.stringify(trimArr));
        if (itemsSearchBar.length === 0) setItemsSearchBar([...trimArr]);

        // blur after enter
        document.activeElement && document.activeElement.blur();
      }
    }
  };

  const settingItemsSearch = (dataLocalStorage) => {
    const arryLocalStore =
      Array.isArray(dataLocalStorage) === true
        ? dataLocalStorage
        : JSON.parse(dataLocalStorage);

    const dataItemsSearch = [].concat(
      ...arryLocalStore.map((item, index) => {
        return {
          key: parseInt(index + 1),
          id: parseInt(index + 1),
          value: item,
          label: item,
        };
      }),
    );

    // console.log(dataItemsSearch)
    setItemsSearchBar([...dataItemsSearch]);
  };

  const handleFocus = () => {
    if (itemsSearchBar.length > 0) {
      setIsOpenSelect(true);
      settingItemsSearch(getLocalStorage(searchBarPage));

      // if (isContentLibraryPage) {
      //   setIsShowRecentSearch(true);
      // }
    } else {
      setIsOpenSelect(false);
      // if (isContentLibraryPage) {
      //   setIsShowRecentSearch(false);
      // }
    }
  };

  useEffect(() => {
    if (searchBarPage !== "")
      settingItemsSearch(getLocalStorage(searchBarPage));
  }, [searchBarPage]);

  useEffect(() => {
    const arrloc = locPathname.split("/");
    if (
      (arrloc.length === 2 && arrloc.indexOf("my-learning-journey") > -1) ||
      locPathname.indexOf("my-learning-journey/search") > -1
    ) {
      setSearchBarPage("search_mylj");
      dispatch(setSearchBarPosition("search_mylj"));
    } else if (
      (arrloc.length === 2 && arrloc.indexOf("content-library") > -1) ||
      locPathname.indexOf("content-library/search") > -1
    ) {
      if (isCollectionCL === false) {
        setSearchBarPage("search_cl");
        dispatch(setSearchBarPosition("search_cl"));
      } else {
        setSearchBarPage("");
        dispatch(setSearchBarPosition(""));
        setIsOpenTooltipToolbar(false);
      }
    } else {
      setSearchBarPage("");
      dispatch(setSearchBarPosition(""));
      setIsOpenTooltipToolbar(false);
    }
    // console.log(arrloc)
  }, [location, isCollectionCL]);

  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search");

  useEffect(() => {
    if (searchQuery) {
      setValueSearch(searchQuery);
    }
  }, [searchQuery]);

  // const elements = document.getElementsByClassName(
  //   "wrapper-content-items-search",
  // );

  // const updateDropdownMargin = () => {
  //   console.log("bincang");
  //   if (elements.length > 0) {
  //     const parentElement = elements[0].closest(".ant-select-dropdown");
  //     if (parentElement) {
  //       // parentElement.style.marginTop = isOpenTooltipToolbar ? "26%" : "13%";
  //       parentElement.style.width = isOpenSelect && "87%";
  //       parentElement.style.marginLeft = isOpenSelect && "24px";
  //     }
  //   }
  // };

  // useEffect(() => {
  //   console.log("isOpenSelect:", isOpenSelect);
  //   console.log("isOpenTooltipToolbar:", isOpenTooltipToolbar);
  //   if (isOpenSelect || isOpenTooltipToolbar) {
  //     updateDropdownMargin();
  //   }

  //   return () => {
  //     if (elements.length > 0) {
  //       const parentElement = elements[0].closest(".ant-select-dropdown");
  //       if (parentElement) {
  //         // parentElement.style.marginTop = "13%";
  //       }
  //     }
  //   };
  // }, [isOpenTooltipToolbar, isOpenSelect, elements]);

  // useEffect(() => {
  //   if (historySearch && historySearch.length > 0 && isContentLibraryPage) {
  //     const parsedHistory = JSON.parse(historySearch);
  //     setItemsSearchBar(parsedHistory);
  //   }
  // }, [historySearch]);

  // useEffect(() => {
  //   if (isShowRecentSearch) {
  //     mainState.setIsFocusedSearch(true);
  //   } else {
  //     mainState.setIsFocusedSearch(false);
  //   }
  // }, [isShowRecentSearch]);

  return (
    <Row
      align={"middle"}
      style={{
        height: isContentLibraryPage ? "100%" : "auto",
        marginBottom: isContentLibraryPage ? 0 : 10,
        width: "100%",
      }}
    >
      <>
        <Col span={24} style={{ height: "100%" }}>
          <div
            className="search-bar"
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <Tooltip
              placement="bottomLeft"
              title={tooltipMessage}
              open={isOpenTooltipToolbar}
              arrow
              align={{ offset: [15, 10] }}
              getPopupContainer={(trigger) => {
                return trigger;
              }}
            >
              <AutoComplete
                // optionLabelProp="value"
                className="search-bar-autocomplete-mobile"
                showSearch
                size="middle"
                placeholder={t("feature.feature_search.what_do_you")}
                allowClear={<CloseOutlined />}
                suffixIcon={<SearchOutlined style={{ fontSize: 14 }} />}
                style={{
                  width: "100%",
                  textAlign: "left",
                }}
                onSelect={handleSelectSearchBar}
                onSearch={handleOnSearch}
                onKeyDown={handleEnter}
                onFocus={handleFocus}
                onBlur={() => {
                  setIsOpenSelect(false);
                  // setIsShowRecentSearch(false);
                }}
                searchValue={valueSearch}
                autoClearSearchValue={false}
                filterOption={false}
                maxLength={50}
                open={isOpenSelect}
                // open={true}
                value={valueSearch}
                autoFocus={false}
                dropdownAlign={{
                  points: ["tl", "bl"], // force dropdown ke bawah (top-left ke bottom-left)
                }}
                dropdownStyle={{
                  marginTop: isOpenTooltipToolbar ? 60 : 16,
                }}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                popupClassName="wrapper-content-items-search-dropdown"
              >
                {itemsSearchBar !== undefined &&
                  itemsSearchBar.length > 0 &&
                  itemsSearchBar.map((task, index) => {
                    return (
                      <Option
                        key={index}
                        value={task.value}
                        label={task.label}
                        className="wrapper-content-items-search"
                        style={{
                          fontSize: 14,
                          padding: "0px 8px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 14,
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            color: colorTextTitle,
                            flex: "1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            marginRight: "8px",
                          }}
                        >
                          {task.label}
                        </span>
                        <span style={{ float: "right" }}>
                          <CloseOutlined
                            style={{
                              width: 12,
                              height: 12,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteOption(task.value);
                            }}
                          />
                        </span>
                      </Option>
                    );
                  })}
              </AutoComplete>
            </Tooltip>
          </div>
        </Col>

        {/* Recent Search in Content Library */}
        {/* {isContentLibraryPage &&
          itemsSearchBar.length > 0 &&
          isShowRecentSearch && (
            <div
              style={{
                lineHeight: "normal",
                margin: "22px 0 0 -25px",
                zIndex: 1,
                width: "calc(100% + 50px)",
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 16,
                  lineHeight: "30px",
                  color: colorTextTitleMobile,
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 36,
                }}
              >
                <HistoryOutlined style={{ marginRight: "8px" }} /> Recent Search
              </div>

              <List
                dataSource={itemsSearchBar}
                renderItem={(item, index) => (
                  <List.Item
                    style={{
                      padding: `${index === 0 ? "0" : "14px"} 4px 14px 0`,
                      borderBottom: "1px solid #eee",
                      flexWrap: "nowrap",
                    }}
                    actions={[
                      <CloseOutlined
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteOption(item);
                        }}
                        style={{ fontSize: 14, color: "#888" }}
                      />,
                    ]}
                    onClick={(v) => {
                      v.stopPropagation();
                      handleSelectSearch(item);
                    }}
                  >
                    <span
                      style={{
                        color: colorTextTitleMobile,
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: "18px",
                        textAlign: "left",
                      }}
                    >
                      {item}
                    </span>
                  </List.Item>
                )}
              />
            </div>
          )} */}
        {/* End Recent Search */}
      </>
    </Row>
  );
};

export default SearchMobileVersion;
